import { getPartnerContacts } from './getPartnerContacts'

export default {
  getPartnerContacts
}
